// src/components/listing/ListHeader.jsx
import React from "react";
import { FaPlus } from "react-icons/fa";
import BtnLimpiarSeleccion from "../buttons/BtnLimpiarSeleccion";

export default function ListHeader({
  title,

  // filtros
  onFilterClick,
  filters = {},
  onClearFilters,

  // agregar
  showAdd = false,
  addLabel = "Agregar",
  onAddClick,

  // paginación
  pageSize,
  onPageSizeChange,
  pageSizeOptions = [30, 40, 50],
}) {
  return (
    <div className="page-header">
      {/* TÍTULO */}
      <h1 className="page-title">📄 {title}</h1>

      {/* TOOLBAR */}
      <div className="toolbar">
        <div className="inline-flex items-center gap-2 max-md:flex max-md:flex-wrap max-md:justify-center">
          {onFilterClick && (
            <button className="btn-fil" onClick={onFilterClick}>
              Ver Filtros
            </button>
          )}

          {/* ✅ MISMA LÓGICA QUE HOY:
              se muestra SOLO si filters tiene contenido */}
          {onClearFilters && (
            <BtnLimpiarSeleccion
              filters={filters}
              onClick={onClearFilters}
              className="btn-fil"
            />
          )}

          {showAdd && onAddClick && (
            <button
              className="btn-fil inline-flex items-center gap-2"
              onClick={onAddClick}
            >
              <FaPlus />
              {addLabel}
            </button>
          )}
        </div>
      </div>

      {/* MOSTRAR POR PÁGINA */}
      {pageSize && onPageSizeChange && (
        <div className="control-block max-md:w-full">
          <label className="label-strong">Mostrar por página:</label>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="select max-md:w-full"
          >
            {pageSizeOptions.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
